import type React from 'react'
import { useSelector } from 'react-redux'
import keyBy from 'lodash/fp/keyBy'
import { Provider } from '~/entities/provider'
import { Avatar, Box, Tooltip } from '@mui/material'

const OTHER_PROVIDER_AVATAR_SX = {
  border: '.1rem solid',
  borderColor: 'primary.main',
  bgcolor: 'primary.lighter',
  color: 'text.primary',
  fontSize: '1.5rem',
}

interface Props {
  patientId: number
}

const CurrentProfileViewers: React.FC<Props> = props => {
  const me = useSelector(state => state.me)
  const providers = useSelector(state => state.providers)
  const providersById = keyBy('id', providers)
  const viewingState = useSelector(state => state.chat.viewing)
  const currentlyViewingThisPatient = Object.keys(viewingState).filter(
    providerId =>
      viewingState[providerId] == props.patientId && me.id && providerId != me.id.toString(),
  )
  if (currentlyViewingThisPatient.length == 0) return null

  const providersToShow = currentlyViewingThisPatient.reduce((arr, el) => {
    const provider = providersById[el]
    if (provider) {
      arr.push(provider)
    }
    return arr
  }, [] as Provider[])

  const providerBubbles: React.JSX.Element[] = []

  for (const [index, provider] of providersToShow.entries()) {
    if (index === 2 && providersToShow.length > 3) {
      const remainingProviders = providersToShow.slice(2)
      const names = remainingProviders.map(
        remaining => `${remaining.first_name} ${remaining.last_name}`,
      )
      const remainingNames = `${names.slice(0, -1).join(', ')}, & ${names.at(-1)}`
      providerBubbles.push(
        <Tooltip title={remainingNames} aria-label="add" key={index}>
          <Avatar sx={OTHER_PROVIDER_AVATAR_SX}>+{remainingProviders.length}</Avatar>
        </Tooltip>,
      )
      break
    }

    const fullName = `${provider.first_name ?? ''} ${provider.last_name ?? ''}`
    const initials = `${(provider.first_name ?? '').slice(0, 1)}${(provider.last_name ?? '').slice(
      0,
      1,
    )}`

    providerBubbles.push(
      <Tooltip title={fullName} aria-label="add" key={index}>
        <Avatar sx={OTHER_PROVIDER_AVATAR_SX}>{initials}</Avatar>
      </Tooltip>,
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ display: 'flex' }}>{providerBubbles}</Box>
    </Box>
  )
}

export default CurrentProfileViewers
